import { API, API_POST } from "../../Config";

export const handleSendNotification = (payload) => {

  const f = new FormData();

  f.append("title", payload.title);
  f.append("message", payload.message);
  f.append("type", payload.type);
  
  if (payload.type === "1") {
    f.append("ids", payload.ids);
  }

  return API_POST(API.SendNotification, f);
};
